import {useState} from 'react';

import {Popup, Button} from '@deviceinsight/ng-ui-basic-components';

import imgIconCalendar from '../../../../../assets/icon_calendar.svg';
import imgTriangleDown from '../../../../../assets/triangle_down.svg';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {KpiTimeframeType, KpiPeriodTypeType} from '../kpiUtils';

type OnChangeFunctionType = (arg0: KpiTimeframeType, arg1?: KpiPeriodTypeType | null | undefined) => void;

type Props = {
	periodTimeframe: KpiTimeframeType;
	periodType: KpiPeriodTypeType | null | undefined;
	onChange: OnChangeFunctionType;
};

const items: Array<{
	periodTimeframeValue: KpiTimeframeType;
	periodTypeValues: KpiPeriodTypeType[];
}> = [
	{
		periodTimeframeValue: 'CURRENT',
		periodTypeValues: ['DAY', 'WEEK', 'MONTH']
	},
	{
		periodTimeframeValue: 'LAST',
		periodTypeValues: ['HOUR', 'DAY', 'WEEK', 'MONTH']
	},
	{
		periodTimeframeValue: 'PAST',
		periodTypeValues: ['HOUR', 'DAY', 'WEEK', 'MONTH']
	},
	{
		periodTimeframeValue: 'CUSTOM',
		periodTypeValues: []
	}
];

function ButtonLabel({
	periodTimeframe,
	periodType
}: {
	periodTimeframe: KpiTimeframeType;
	periodType: KpiPeriodTypeType | null | undefined;
}) {
	if (periodType) {
		return (
			<>
				<Trans i18nKey={`dashboard.widgets.kpi.periodTimeframe.${periodTimeframe}`}>{periodTimeframe}</Trans>
				&nbsp;
				<Trans i18nKey={`dashboard.widgets.kpi.periodType.${periodType}`}>{periodType}</Trans>
			</>
		);
	} else {
		return <Trans i18nKey={`dashboard.widgets.kpi.periodTimeframe.${periodTimeframe}`}>{periodTimeframe}</Trans>;
	}
}

function PeriodTimeframeLabel({
	periodTimeframe,
	onClick
}: {
	periodTimeframe: KpiTimeframeType;
	onClick: (arg0: KpiTimeframeType) => void;
}) {
	if (periodTimeframe === 'CUSTOM') {
		return (
			<div className="item-text" onClick={() => onClick(periodTimeframe)}>
				<Trans key={periodTimeframe} i18nKey={`dashboard.widgets.kpi.periodTimeframe.${periodTimeframe}`}>
					{periodTimeframe}
				</Trans>
			</div>
		);
	} else {
		return (
			<div className="item-text">
				<Trans key={periodTimeframe} i18nKey={`dashboard.widgets.kpi.periodTimeframe.${periodTimeframe}`}>
					{periodTimeframe}
				</Trans>
			</div>
		);
	}
}

function PeriodTypeLabel({
	periodTimeframe,
	periodType,
	onClick
}: {
	periodTimeframe: KpiTimeframeType;
	periodType: KpiPeriodTypeType;
	onClick: OnChangeFunctionType;
}) {
	return (
		<div className="subitem" key={periodType} onClick={() => onClick(periodTimeframe, periodType)}>
			<Trans i18nKey={`dashboard.widgets.kpi.periodType.${periodType}`}>{periodType}</Trans>
		</div>
	);
}

export default function TimePeriodPicker({periodTimeframe, periodType, onChange}: Props) {
	const [active, setActive] = useState<boolean>(false);

	const toggle = () => setActive(!active);

	return (
		<Popup
			active={active}
			onHide={toggle}
			handler={
				<Button
					onClick={toggle}
					className={periodType === 'DAY' ? 'time-period-picker-single-day-selected' : 'time-period-picker'}>
					<img src={imgIconCalendar} alt="calendar icon" />
					&nbsp;
					<ButtonLabel periodTimeframe={periodTimeframe} periodType={periodType} />
					&nbsp;
					<img src={imgTriangleDown} alt="triangle down" />
				</Button>
			}>
			<div className="di multimenu period-picker-multimenu">
				<div className={`drop bottom ${active ? 'show' : ''}`}>
					{items.map(({periodTimeframeValue, periodTypeValues}) => (
						<div className="item" key={periodTimeframeValue}>
							<PeriodTimeframeLabel
								periodTimeframe={periodTimeframeValue}
								onClick={(timeframeValue: KpiTimeframeType) => {
									onChange(timeframeValue);
									setActive(false);
								}}
							/>
							{periodTimeframeValue !== 'CUSTOM' && (
								<div className="item-more icon triangle">
									<div className="item-more-submenu">
										{periodTypeValues.map((periodTypeValue) => {
											return periodTypeValue ? (
												<PeriodTypeLabel
													key={periodTypeValue}
													periodTimeframe={periodTimeframeValue}
													periodType={periodTypeValue}
													onClick={(timeframeValue, typeValue) => {
														onChange(timeframeValue, typeValue);
														setActive(false);
													}}
												/>
											) : null;
										})}
									</div>
								</div>
							)}
						</div>
					))}
				</div>
			</div>
		</Popup>
	);
}
